module.exports = __webpack_public_path__ + "p6_img3.jpg?bf8d22bd47299024762e318d3f5095bb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p6/p6_img3.jpg
// module id = 123
// module chunks = 0